export default __webpack_public_path__ + "static/media/768.47d02470.png";